import { submitRfpMutation, submitRfpDttMutation, SubmitRfpResponse } from '@marriott/mi-groups-graphql';
import { useMutationTransformer } from '../../hooks';

type SubmitRfp = { groupsSubmitRfp: SubmitRfpResponse };

type SubmitRfpDtt = {
  sales: {
    groupSales: {
      createRfp: SubmitRfpResponse;
    };
  };
};

export const useSubmitRfp = () => {
  return useMutationTransformer<SubmitRfp, SubmitRfpDtt>({
    currentMutation: submitRfpMutation,
    dttMutation: submitRfpDttMutation,
    onTransform: data => {
      return {
        sales: {
          groupSales: {
            createRfp: data.groupsSubmitRfp,
          },
        },
      };
    },
  });
};
